import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
import PrismicReact from 'prismic-reactjs';
import MetaTags from '../components/MetaTags';
import InfoSection from '../components/ProductPage/InfoSection';
import OtherSection from '../components/ProductPage/OtherSection';
import LoadingOverlay from '../components/LoadingOverlay';

class ProductPage extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      doc: null,
      notFound: false,
    }
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'product_page' && result.uid === props.computedMatch.params.uid) 

      this.setState({doc})
      props.getActiveDoc(doc)
    }
  }

  render() {
    if(this.state.doc) {
      let {
        prismicCtx
      } = this.props
      const document = this.state.doc
      const docData = document.data
      
      return (
          <main id="productPage" className="product-page">
            <MetaTags 
              title={`${docData.meta_title ? docData.meta_title : 'AltaVie'}`}
              description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
            />
            <InfoSection
              document={docData}
              linkResolver={prismicCtx.linkResolver}
            />
            {
              docData.body.map((slice, index) => {
                if(slice.slice_type === 'other_strains_section') {
                  return (
                    <OtherSection
                      key={index}
                      slice={slice}
                      linkResolver={prismicCtx.linkResolver}
                    />
                  )
                }
              })
            }
          </main>
      )
    }
    return <LoadingOverlay />
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
  activeDoc: state.prismic.activeDoc,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getActiveDoc: prismicActions.getActiveDoc, },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage)


// WEBPACK FOOTER //
// ./src/pages/ProductPage.js